import { Exclude, Type } from 'class-transformer'
import { Guid } from 'guid-typescript'

import {
  BotProperty,
  GroupedBotProperty,
} from '../../../../../../../BotProperties/components/Properties/types'
import BaseCondition from './ConditionTypes/BaseCondition'
import BetweenCondition from './ConditionTypes/BetweenPropertyCondition'
import HasLabelConditions
  from './ConditionTypes/LabelConditions/HasLabelConditions'
import HasNotLabelCondition from './ConditionTypes/LabelConditions/HasNotLabelCondition'
import PropertyCondition from './ConditionTypes/PropertyCondition'
import IsNotSetPropertyCondition from './ConditionTypes/SetPropertyConditions/IsNotSetPropertyCondition'
import IsSetPropertyCondition from './ConditionTypes/SetPropertyConditions/IsSetPropertyCondition'

export enum ConditionType {
  HasLabel = 'HasLabel',
  HasNotLabel = 'HasNotLabel',
  Property = 'Property',
  IsSetProperty = 'IsSetProperty',
  IsNotSetProperty = 'IsNotSetProperty',
  BetweenProperty = 'BetweenProperty',
}

export enum ConditionOptions {
  IgnoreCase = 'IgnoreCase',
}

export class ConditionsGroup {
  success_output!: number

  @Type(() => BaseCondition, {
    keepDiscriminatorProperty: true,
    discriminator: {
      property: 'type',
      subTypes: [
        { name: ConditionType.BetweenProperty, value: BetweenCondition },
        { name: ConditionType.IsSetProperty, value: IsSetPropertyCondition },
        { name: ConditionType.IsNotSetProperty, value: IsNotSetPropertyCondition },
        { name: ConditionType.HasLabel, value: HasLabelConditions },
        { name: ConditionType.HasNotLabel, value: HasNotLabelCondition },
        { name: ConditionType.Property, value: PropertyCondition }
      ]
    }
  })
  conditions!: Array<BaseCondition>

  @Exclude()
  guid: string = Guid.create().toString()
}

export type ConditionsNodeProps = {
  properties: () => Array<GroupedBotProperty>
  labels: () => { [key: string]: string },
  createNewProperty: (path: string, name: string, parent?: number) => Promise<Array<BotProperty>>
  createNewLabel: (label: string) => Promise<{ index: number }>
}
